import { Button, Progress } from "antd";
import PrimaryButton from "modules/SubComponents/Buttons/PrimaryButton";
import SecondaryButton from "modules/SubComponents/Buttons/SecondaryButton";
import React, { useEffect, useState } from "react";
import editIcon from "assets/icons/pen.svg";
import DraggerUploader from "modules/SubComponents/Upload/DraggerUploader";
import { baseUrl, handleLogout, token } from "services";
import axios from "axios";
import { toastError, toastSuccess } from "helpers/toasters";

export default function Uploader({ title, imgPath, setImgPath, keyName, api }) {
  const [onProgress, setOnProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [showUploader, setShowUploader] = useState(false);
  const [newImage, setNewImage] = useState(null);

  // Handle file upload for competition photos
  const handleImageUpload = (img) => {
    setNewImage(img);
    setShowUploader(false);
    console.log("New competition img selected:", img);
  };

  // Submit the new competition image
  const editImage = async () => {
    if (!newImage) {
      alert("Please select a new image to upload.");
      return;
    }
    const data = {
      [keyName]: `${newImage}`,
    };

    try {
      const response = await axios.put(`${baseUrl}${api}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.isSuccess) {
        setImgPath(newImage);
        setShowUploader(false);
        setNewImage(null);
        setShowProgress(false);
        toastSuccess(response?.data?.message || "Updated successfully.");
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        handleLogout();
      }
      console.error("Error uploading competition image:", error);
      toastError("Failed to update image.");
    }
  };

  return (
    <div className="tv-photos__upload-section">
      <h3>{title}</h3>
      <div className="tv-photos__img-container">
        {imgPath && !showUploader ? (
          <>
            <img
              loading="lazy"
              src={`${baseUrl}${newImage || imgPath}`}
              alt="Competition"
            />
            {!newImage && (
              <Button
                type="text"
                icon={<img src={editIcon} alt="Edit" />}
                onClick={() => setShowUploader(true)}
              />
            )}
          </>
        ) : (
          <DraggerUploader
            setProgressPercent={setOnProgress}
            setShowProgressBar={setShowProgress}
            setFilePath={handleImageUpload}
            formDataType="img"
            acceptedTypes="image/png, image/jpeg, image/jpg"
            disableMe={false}
          >
            <p>Drag & drop photo here or click to upload</p>
          </DraggerUploader>
        )}
      </div>
      {showProgress && (
        <Progress
          style={{ width: "95%", margin: "auto" }}
          percent={onProgress}
        />
      )}
      <div className="tv-photos__btns">
        {newImage && (
          <PrimaryButton
            type="primary"
            onClick={editImage}
            buttonName={"Save"}
          />
        )}
        {showUploader && (
          <SecondaryButton
            onClick={() => setShowUploader(false)}
            buttonName={"Cancel"}
          />
        )}
      </div>
    </div>
  );
}
